<template>
  <Dialog :open="show" @update:open="onDialogUpdate">
    <DialogScrollContent>
      <DialogHeader>
        <DialogTitle>
          {{ $t('Booking information') }}
        </DialogTitle>
      </DialogHeader>
      <div v-if="booking">
        <ul class="list-group list-group-flush">
          <li class="list-group-item d-flex align-items-center tw:gap-2">
            {{ $t('Status:') }}
            <BookingStatus v-if="bookingDetails?.status" :status="bookingDetails.status" />
          </li>
          <li class="list-group-item d-flex align-items-center">
            {{ $t('Start at:') }} {{ bookingDetails?.local_start_at ? displayDate(bookingDetails.local_start_at, true) : ''}}
          </li>
          <li class="list-group-item d-flex align-items-center">
            {{ $t('End at:') }} {{ bookingDetails?.end_at ? displayDate(bookingDetails.local_end_at, true) : ''}}
          </li>

          <template v-if="bookingDetails?.equipment">
            <li class="list-group-item">
              <EquipmentInfo :item="bookingDetails?.equipment" />
            </li>
          </template>

          <template v-if="bookingDetails?.registration">
            <li class="list-group-item">
              <RegistrationInfo :registration="bookingDetails.registration" />
            </li>
          </template>
        </ul>
        <div class="mt-4">
          <a :href="booking.url" target="_blank" class="btn btn-primary w-100">
            {{ $t('View booking') }}
          </a>
        </div>
      </div>
    </DialogScrollContent>
  </Dialog>
</template>

<script setup>
import { displayDate } from "@/utils/date";
import { ref, watch, defineProps } from "vue";
import BookingModel from '../../models/Booking';
import { Dialog, DialogScrollContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import RegistrationInfo from "@/components/registration/RegistrationInfo.vue";
import EquipmentInfo from "@/components/equipment/EquipmentInfo.vue";
import BookingStatus from "@/components/booking/BookingStatus.vue";

const props = defineProps({
  show: {
    default: false,
  },
  booking: {
    required: true,
  }
})

const bookingDetails = ref(null)

watch(
  () => props.show,
  (newValue) => {
    if(newValue) {
      setBookingDetails();
    }
  }
)
const setBookingDetails = async () => {
  const bookingModel = BookingModel;
  bookingModel.find(props.booking.uuid)
    .then(response => {
      bookingDetails.value = response.data;
    });
}
const emit = defineEmits(["close"]);
const onDialogUpdate = (isOpen) => {
  if (! isOpen) {
    emit("close");
  }
}
</script>
